import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IBulkEmailOptionsResponse,
} from '../types';
import {
  BULK_EMAILS_OPTIONS_QUERY_KEY,
  BULK_EMAILS_OPTIONS_URL,
  BULK_EMAILS_PERMISSIONS,
} from '../constants';

export default function useBulkEmailsOptionsQuery(): IContextQueryResult<
  IBulkEmailOptionsResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IBulkEmailOptionsResponse>({
    queryKey: [BULK_EMAILS_OPTIONS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IBulkEmailOptionsResponse>(
      BULK_EMAILS_OPTIONS_URL,
      {
        signal,
        permission: BULK_EMAILS_PERMISSIONS.SHOW,
      },
    ),
  });
}
